import type { TApiKey, TApiKeyScope } from './api';

// `*` is not a scope value: it is what omitting every scope means.
export const SCOPE_OPTIONS: readonly { value: TApiKeyScope; label: string; implies?: string }[] = [
  { value: 'events:read', label: 'Read events' },
  { value: 'events:replay', label: 'Replay events', implies: 'can also read them' },
  { value: 'events:retry', label: 'Retry failed deliveries', implies: 'can also read events' },
  { value: 'config:read', label: 'Read sources, flows and destinations' },
  {
    value: 'config:write',
    label: 'Change sources, flows and destinations',
    implies: 'can also read them',
  },
  { value: 'metrics:read', label: 'Read metrics' },
  { value: 'flows:run', label: 'Run flows', implies: 'can also read the setup' },
];

export const scopeWords = (scopes: readonly string[]): string =>
  scopes.length === 0 || scopes.includes('*')
    ? 'Everything'
    : scopes
        .map((scope) => SCOPE_OPTIONS.find((option) => option.value === scope)?.label ?? scope)
        .join(', ');

export type TKeyState = 'revoked' | 'unused' | 'used';

export const keyState = (key: TApiKey): TKeyState => {
  if (key.revokedAt) return 'revoked';
  return key.lastUsedAt ? 'used' : 'unused';
};

export const isRevoked = (key: TApiKey): boolean =>
  key.revokedAt !== null && key.revokedAt !== undefined;
